import { render, staticRenderFns } from "./ShhfLicensor.vue?vue&type=template&id=b2b895c2&scoped=true"
import script from "./ShhfLicensor.vue?vue&type=script&lang=js"
export * from "./ShhfLicensor.vue?vue&type=script&lang=js"
import style0 from "./ShhfLicensor.vue?vue&type=style&index=0&id=b2b895c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b895c2",
  null
  
)

export default component.exports